<script setup lang="ts">
import Card from 'primevue/card'

/**
 * Envoltorio de `primevue/card` con slot por defecto.
 *
 * PrimeVue 4 `Card` solo expone slots con nombre (`header`, `title`, `subtitle`,
 * `content`, `footer`). Escribir `<Card> ...contenido... </Card>` descarta el
 * contenido en silencio porque la plantilla del componente no renderiza
 * `<slot />`. Este componente traduce el slot por defecto a `#content` para que
 * los usages se comporten como en PrimeVue 3.
 */
defineOptions({ name: 'AppCard', inheritAttrs: true })
</script>

<template>
  <Card>
    <template
      v-if="$slots.header"
      #header
    >
      <slot name="header" />
    </template>
    <template
      v-if="$slots.title"
      #title
    >
      <slot name="title" />
    </template>
    <template
      v-if="$slots.subtitle"
      #subtitle
    >
      <slot name="subtitle" />
    </template>
    <template
      v-if="$slots.footer"
      #footer
    >
      <slot name="footer" />
    </template>
    <template #content>
      <slot />
    </template>
  </Card>
</template>